import { FC } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import { Icon } from '@components/icons';
import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    onSubmit: () => void;
    onClose: () => void;
}

const KycInfo: FC<IProps> = ({ onSubmit, onClose }) => {
    const { submitLocale } = useLocales();
    return (
        <div className={styles.steps_content_wrapper}>
            <Typography variant="h4" className={styles.title} alignment="center">
                Get ready to verify your identity
            </Typography>
            <div className={styles.steps_wrapper}>
                <div className={styles.step_wrapper}>
                    <Icon name="identity" />
                    <div className={styles.step_text}>
                        <Typography variant="body4">
                            Prepare a valid government-issued ID (passport or driver's license)
                        </Typography>
                    </div>
                </div>
                <div className={styles.step_wrapper}>
                    <Icon name="bulb" />
                    <div className={styles.step_text}>
                        <Typography variant="body4">
                            Make sure you're in a well-lit place and away from a direct light source
                        </Typography>
                    </div>
                </div>
                <div className={styles.step_wrapper}>
                    <Icon name="kyc" />
                    <div className={styles.step_text}>
                        <Typography variant="body4">
                            Be prepared to take a selfie and a photo of your identity document
                        </Typography>
                    </div>
                </div>
            </div>
            <Typography variant="body4" className={styles.description}>
                Your privacy matters — your documents are encrypted and securely stored
            </Typography>
            <div className={styles.actions}>
                <Button size="medium" variant="outlined-primary" onClick={onClose}>
                    {submitLocale('do_this_later')}
                </Button>
                <Button size="medium" variant="primary" onClick={onSubmit}>
                    {submitLocale('im_ready')}
                </Button>
            </div>
        </div>
    );
};

export default KycInfo;
